<template>
  <design-preview v-if="loaded" v-bind:isMine="false" v-bind:idTemplate="templateId" v-model="templateId" :key="templateId" />
</template>

<script>
import DesignPreview from "./DesignPreview";

export default {
  name: "Preview",
  data: function() {
    return { templateId: "", loaded: true };
  },
  watch:{
    $route (to, from) {
        this.templateId = this.$route.params.id;
    },
    templateId(to, from) {
      if (to && from && to != from) {
        let params = { id: to };
        if (params.id) {
          this.$router.push({ name: 'Preview Design', params: params});
        }
         
      }
    }
  },
  created: function() {
    this.templateId = this.$route.params.id;
    console.log("TemplateId created: " + this.templateId);
  },
  components: { DesignPreview }
};
</script>